import React, { useEffect, useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  fetchStart,
  fetchEnd,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { useDispatch } from "react-redux";
import { apiUrl } from "../../../dataProvider";
import WithProps from "../../Custom/WithProps";
import { EditToolBar } from "../../Signet/util";
import { validateRequired } from "../../../utils/Validations";

const useStyles = makeStyles({
  container: {
    width: "100%",
  },
});

const useFinishChoices = () => {
  const [choices, setChoices] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchFinishes = async () => {
      try {
        dispatch(fetchStart());
        const response = await axios.get(`${apiUrl}/custom-pricing/finishes`);
        let data = response.data?.data || response.data || [];
        if (!Array.isArray(data)) data = [];

        const mapped = data.map((item, index) => {
          const id =
            item.id ??
            item.finish_id ??
            item.sku_code ??
            item.code ??
            index;
          const name =
            item.name ??
            item.label ??
            item.display_name ??
            item.sku_code ??
            String(id);
          return { id, name };
        });
        setChoices(mapped);
      } catch (e) {
        console.error("Error fetching finishes", e);
        setChoices([]);
      } finally {
        dispatch(fetchEnd());
      }
    };

    fetchFinishes();
  }, [dispatch]);

  return choices;
};

const RingFinishEdit = (props) => {
  const classes = useStyles();
  const finishChoices = useFinishChoices();

  return (
    <Edit {...props} className="overflow-visible">
      <WithProps>
        {({ record, ...rest }) => (
          <SimpleForm
            record={record}
            {...rest}
            undoable={false}
            toolbar={<EditToolBar delete />}
          >
            <Grid container className={classes.container} spacing={2}>
              <Grid item xs={12} sm={6}>
                <SelectInput
                  source="first_ring_finish_id"
                  label="First Ring Finish"
                  choices={finishChoices}
                  validate={[validateRequired]}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput
                  source="second_ring_finish_id"
                  label="Second Ring Finish"
                  choices={finishChoices}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput
                  source="accent_ring_finish_id"
                  label="Accent Ring Finish"
                  choices={finishChoices}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput
                  source="netsuite_id"
                  label="Netsuite ID"
                  fullWidth
                  validate={[validateRequired]}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput
                  source="netsuite_value"
                  label="Netsuite Value"
                  fullWidth
                  validate={[validateRequired]}
                />
              </Grid>
            </Grid>
          </SimpleForm>
        )}
      </WithProps>
    </Edit>
  );
};

export default RingFinishEdit;
